const STORAGE_KEY = 'buzzim.media.device-preferences';

function readPreferences() {
	if (typeof localStorage === 'undefined') {
		return {};
	}
	try {
		const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
		return value && typeof value === 'object' ? value : {};
	} catch (error) {
		return {};
	}
}

function writePreferences(value) {
	if (typeof localStorage === 'undefined') {
		return;
	}
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
	} catch (error) {
		// 本地存储不可用时仍使用系统默认设备。
	}
}

export function getPreferredDeviceId(kind) {
	const value = readPreferences()[kind];
	return typeof value === 'string' && value ? value : '';
}

export function setPreferredDeviceId(kind, deviceId) {
	const preferences = readPreferences();
	if (deviceId) {
		preferences[kind] = String(deviceId);
	} else {
		delete preferences[kind];
	}
	writePreferences(preferences);
}

export function clearPreferredDeviceId(kind) {
	setPreferredDeviceId(kind, '');
}

export function applyPreferredDevice(kind, constraints) {
	const deviceId = getPreferredDeviceId(kind);
	if (!deviceId) {
		return constraints;
	}
	const current = constraints === true || !constraints ? {} : { ...constraints };
	return { ...current, deviceId: { ideal: deviceId } };
}

export function removePreferredDeviceId(constraints, kind) {
	const result = { ...constraints };
	if (result[kind] && typeof result[kind] === 'object') {
		result[kind] = { ...result[kind] };
		delete result[kind].deviceId;
	}
	return result;
}

export function removePreferredDeviceIds(constraints) {
	return ['video', 'audio'].reduce(removePreferredDeviceId, constraints);
}

export function clearPreferredDevices() {
	writePreferences({});
}
